export class MPCode{
    constructor(public id: number,  public categories: number[],public final_product_id: string,  public productCode: string, public MTRL: number) { }
}